import React, { Component } from "react";
import { Row, Col, ProgressBar, Image, Button } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import DropdownComp from "../../components/commonDropdown";
import { Bar } from "react-chartjs-2";

class TutorEarning extends Component {
  constructor() {
    super();

    this.state = {};
  }

  componentDidMount = () => {
    // get Token
    let token = JSON.parse(localStorage.getItem("userDetail"));
    token = `Bearer ${token?.token}`;
  };

  render() {
    const {} = this.state;
    let chartData = {
      labels: [
        "jan",
        "feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: [
        {
          label: "Received earnings",
          type: "bar",
          stack: "Base",
          backgroundColor: "#007ab5",
          data: [60, 60, 70, 83, 74, 65, 46, 72, 76, 54, 75, 66],
        },
        {
          label: "Upcomming earnings",
          type: "bar",
          stack: "Base",
          backgroundColor: "#8fbdd4",
          data: [0, 0, 0, 0, 0, 0, 36, 0, 0, 0, 0, 0],
        },
      ],
    };

    return (
      <div className="tutor-earning-div">
        <Row className="tutor-earning-Row">
          <Col lg={4} md={4} sm={12} xs={12} className="money-Col">
            <div className="flex-center-center">
              <Image src={require("./../../assets/icons/pound-black.png")} />
              <h3> 330.33</h3>
            </div>
            <p>2020 total earning</p>
          </Col>
          <Col lg={4} md={4} sm={12} xs={12} className="money-Col">
            <div className="flex-center-center">
              <Image src={require("./../../assets/icons/pound-black.png")} />
              <h3> 220.33</h3>
            </div>
            <p>2020 earnings recived</p>
          </Col>
          <Col lg={4} md={4} sm={12} xs={12} className="money-Col">
            <div className="flex-center-center">
              <Image src={require("./../../assets/icons/pound-black.png")} />
              <h3> 40.33</h3>
            </div>
            <p>2020 upcomming earnings</p>
          </Col>
        </Row>
        <div style={{ marginBottom: "50px" }} />

        <Row style={{ margin: "0px" }}>
          {/* <Col lg={12} md={12} sm={12} xs={12} className="flex-center">
            <div className="flex-center receive-div">
              <span receive-div></span>
              <span>Received earnings</span>
            </div>
            <div className="flex-center upcomming-div">
              <span receive-div></span>
              <span>Upcomming earnings</span>
            </div>
          </Col> */}

          <Col lg={12} md={12} sm={12} xs={12}>
            <Bar
              data={chartData}
              options={{
                scales: {
                  xAxes: [
                    {
                      //stacked: true,
                      stacked: true,
                      ticks: {
                        beginAtZero: true,
                        maxRotation: 0,
                        minRotation: 0,
                      },
                    },
                  ],
                  yAxes: [
                    {
                      stacked: true,
                    },
                  ],
                },
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12} style={{ marginTop: "50px" }}>
            <div className="head-div">
              <h3 style={{ color: "#000", fontSize: "600" }}>2020 details</h3>
            </div>
            <div className="value-div flex-between-center">
              <div>Lessons booked</div>
              <div>14</div>
            </div>
            <div className="value-div flex-between-center">
              <div>Lessons rate</div>
              <div>24-25</div>
            </div>
            <div className="value-div flex-between-center">
              <div className="blue-txt">Session transaction history</div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default TutorEarning;
